import { PropsWithChildren, useEffect } from 'react';
import { useFetchMyProfileQuery } from '@api/Trinium/Endpoints/myProfile';
import ApplicationError from '../Components/ErrorHandling/ApplicationError';
import { ApplicationErrorType } from '../Components/ErrorHandling/types';
import { useAppDispatch, useAppSelector } from '../store';
import { authorize, unauthorize } from './authorizationSlice';
import CompanyProgressBar from '../Components/Loading/CompanyProgressBar';

/**
 * Component used for ensuring that the Authenticated User is also an Authorized User of Trinium.
 */
export default function TriniumUserGate(props: PropsWithChildren) {
	const appDispatch = useAppDispatch();
	const { isAuthorized } = useAppSelector((state) => state.authorizationState);
	const { data, isLoading, isError, error } = useFetchMyProfileQuery(undefined);

	useEffect(() => {
		if (!isLoading) {
			appDispatch(data?.userCode ? authorize() : unauthorize());
		}
	}, [data, isLoading, appDispatch]);

	// Undefined indicates we are still determining if they are authorized
	if (isLoading) return <CompanyProgressBar />;

	// false indicates we determined they were not authorized or we got a 401 response
	if ((!isError && !isAuthorized) || (isError && 'status' in error && error.status === 401)) {
		return <ApplicationError type={ApplicationErrorType.Unauthorized} />;
	}

	// Otherwise it was a different type of error
	if (isError) {
		return <ApplicationError type={ApplicationErrorType.Unexpected} />;
	}

	return <>{props.children}</>;
}
